




































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import InputPageWrapper from '@/views/components/input/InputPageWrapper.vue';
import PxNumberInput from '@/views/components/input/formFields/PxNumberInput.vue';
import { UnitSystem } from '@/interfaces/units';
import { ConcreteDesignMetric, IConcreteDesignImperial } from '@/modules/design/interfaces/newConcrete';
import GenericPavementDiagram from '@/modules/design/views/components/GenericPavementDiagram.vue';
import { ILayerDef } from '@/modules/design/interfaces/shared';
import { designStore } from '@/store/store';
import { Route } from 'vue-router';
import ValidatedInputPageWrapper from '@/views/components/input/ValidatedInputPageWrapper.vue';
import { createConcreteValidations } from '@/modules/design/lib/validations/concrete';


@Component({
  components: {
    ValidatedInputPageWrapper,
    GenericPavementDiagram,
    PxNumberInput,
    InputPageWrapper,
  },
})
export default class NewConcreteStructure extends Vue {
  scenarioType = 'New Concrete';

  @Prop() readonly pxDesignId!: string;

  @Prop() readonly page!: number;

  get scenario(): IConcreteDesignImperial | ConcreteDesignMetric {
    return designStore.currentConcrete;
  }

  get scenarioImperial(): IConcreteDesignImperial {
    return designStore.currentConcreteImperial;
  }

  validations() {
    return createConcreteValidations(this.scenarioImperial);
  }

  sync() {
    designStore.setCurrentConcreteScenario(this.scenario);
  }

  save() {
    this.sync();
    designStore.saveCurrentConcreteScenario();
  }

  beforeRouteLeave(to: Route, from: Route, next: Function) {
    this.save();
    next();
  }

  get unitSystemIsImperial() {
    return this.scenario.unitSystem === UnitSystem.Imperial;
  }

  get layers(): ILayerDef[] {
    return [
      {
        name: 'Rigid (JPCP)',
        type: 'concrete',
        thickness: null,
        unit: this.minimumThicknessUnit,
      },
      {
        name: 'Base',
        type: 'base',
        thickness: this.scenarioImperial.baseThickness_in,
        unit: this.minimumThicknessUnit,
      },
      {
        name: 'Subgrade',
        type: 'subgrade',
        thickness: null,
        unit: this.minimumThicknessUnit,
      },
    ];
  }


  fields = [
    {
      key: 'liftTitle',
      label: 'Layer',
    },
    {
      key: 'coefficient',
      label: 'Layer Coefficient',
    },
    {
      key: 'drainage',
    },
    {
      key: 'thickness',
    },
    {
      key: 'edit',
    },
  ];

  get minimumThicknessUnit() {
    return this.unitSystemIsImperial ? 'in' : 'cm';
  }
}


